module.exports = __webpack_public_path__ + "static/img/pic13.c0eed35d.png";